// notification/state.js

export const notificationInitialState = {
  isActive: false,
  type: "success",
  title: "",
  message: "",
  errors: null,
  displayMessages: null,
};
